import { AllLicenseTypes } from '@shared/models/organizations/AllLicenseTypes';
import OrganizationModel from '@shared/models/organizations/OrganizationModel';
import { getLicenseType } from '../organization/LicenseUtils';

export const SalesEmail = 'sales@cephable.com';
export const DefaultOrgName = 'My Team';

const licenseMap: { [key in AllLicenseTypes]: string } = {
    isDeveloperAccess: 'SDK',
    isStudentAccess: 'Education',
    isEmployeeAccess: 'Professional',
    isPlusAccess: 'Plus',
    personal: 'Basic',
};

const getLicenseInformation = (organization: OrganizationModel) => {
    const orgName = organization.name || DefaultOrgName;
    const licenseType = getLicenseType(organization);
    const license = licenseMap[licenseType];
    return { orgName, license };
};

// not i18n-translated since it's an email template
// plus todo: change email messaging by license type ie Plus users will not mention where they work potentially
export const getTrialUpgradeMailTo = (organization: OrganizationModel) => {
    const { orgName, license } = getLicenseInformation(organization);
    const subject = `Request for License Upgrade - ${orgName}`;

    let body: string;
    if (organization.maxMembers === 1) {
        body = `Hi,\n\nI hope this email finds you well. My name is [Your Name]. I have been using Cephable ${license} Free Trial and have been very satisfied with the value it has brought to me.\n\n I am having trouble upgrading and was redirected to email you. Could you please provide me with the next steps to facilitate this process? \n\nThank you, and looking forward to hearing from you soon.\n\nBest regards,\n[Your Full Name]\n[Your Position]\n${orgName}\n[Your Contact Information]`;
    }
    body = `Hi,\n\nI hope this email finds you well. My name is [Your Name], and I am the [Your Position] at ${orgName}. We have been using Cephable ${license} Free Trial and have been very satisfied with the value it has brought to our team.\n\nWe would like to explore the available options for upgrading from the free trial to a full license. Could you please provide us with the next steps to facilitate this process? \n\nThank you, and looking forward to hearing from you soon.\n\nBest regards,\n[Your Full Name]\n[Your Position]\n${orgName}\n[Your Contact Information]`;

    return `mailto:${SalesEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};
export const getManageSubscriptionsMailTo = (organization: OrganizationModel) => {
    const { orgName, license } = getLicenseInformation(organization);
    const subject = `Request for License Subscription Management - ${orgName}`;

    let body: string;
    if (organization.maxMembers === 1) {
        body = `Hi,\n\nI hope this email finds you well. My name is [Your Name]. I have been using Cephable ${license} and was trying to manage my billing, however was not able to get to a billing portal link. Could you please provide me with the next steps to facilitate this process? \n\nThank you, and looking forward to hearing from you soon.\n\nBest regards,\n[Your Full Name]\n[Your Position]\n${orgName}\n[Your Contact Information]`;
    } else {
        body = `Hi,\n\nI hope this email finds you well. My name is [Your Name], and I am the [Your Position] at ${orgName}. We have been using Cephable ${license} and were trying to manage our billing, however were not able to get to a billing portal link. [Add Additional Information about Your Subscriptions] \n\nCould you please provide us with the next steps to facilitate this process? \n\nThank you, and looking forward to hearing from you soon.\n\nBest regards,\n[Your Full Name]\n[Your Position]\n${orgName}\n[Your Contact Information]`;
    }

    return `mailto:${SalesEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};
